<div class="florder-page" @fadeInAnimation>
  <div class="florder-page-title">
    <span class="title">
      {{ 'ADMIN.GENERAL.EPS_USERS' | translate }}
    </span>
    <div class="buttons">
      <eps-button
        label="ADMIN.SHARED.INVITE"
        (buttonClick)="inviteNewEpsUser()"
        buttonIcon="envelope-o"
        *ngIf="userContext.adminRoles.inviteEpsUser"
        ></eps-button>
    </div>
  </div>

  <div class="florder-page-search">
    <admin-eps-user-filter
      [isLoading]="users.loading"
      [salesOrganisations]="adminDefinitions.salesOrganisation"
      (filterUsers)="filterUsers($event)"
    ></admin-eps-user-filter>
  </div>
  <div class="florder-page-list" id="users-list">
    <admin-eps-user-list
      [isLoading]="users.loading"
      [pageNr]="users.pageNr"
      [pageSize]="users.pageSize"
      [sortField]="sortField"
      [sortAscending]="sortAscending"
      [totalItems]="users.totalItems"
      [users]="users.items"
      [isDownloading]="usersSandbox.epsUsersDownloading$ | async"
      (openUser)="openEpsUser($event)"
      (pageChange)="onPageChange($event)"
      (sortFieldChange)="sortFieldChange($event)"
      (sortAscendingChange)="sortAscendingChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
      (downloadList)="downloadList()"
    ></admin-eps-user-list>
  </div>
</div>
